import {Component, Input, OnInit} from '@angular/core';
import {DateParams, ExperimentMap, FilterParams, RefExtendedParams} from "app/models/filter_form.model";
import {ActivatedRoute, Router} from "@angular/router";

import {FilterFormService} from "./filter_form.service";
import {TranslateService} from "app/translate/translate.service";
import merge from "lodash-es/merge";
import * as moment from 'moment-timezone';
import * as qs from 'qs';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import {setCookie, getCookie, limiter} from "app/lib/lib";

import dictionary from "dict/static.json";

import 'selectize/dist/css/selectize.css';
import 'selectize/dist/js/standalone/selectize.min.js';
import {AccessorService} from "../../support/accessor/accessor.service";
import {HelperService} from "../../lib/helper.service";
import {GroupRefService} from "../../support/group_ref/group_ref.service";
import {ReporQueriesModalComponent} from "./report_queries.component";
import {ModalService} from "../modal/base_modal.component";

@Component({
	selector    : 'filterForm',
	templateUrl : './filter_form.component.html',
	providers   : [AccessorService]
})
export class FilterFormComponent implements OnInit {
	dictionary: any;
	
	@Input() public addFilterParams: FilterParams;
	@Input() public isAccessorFilters: boolean = false;
	
	public experimentMap: ExperimentMap = new ExperimentMap();
	public moment = moment;
	
	public prevDateType: string = '';
	
	selectize = {
		config: {
			valueField  : 'mark',
			labelField  : 'mark',
			searchField : 'mark',
			render      : {
				option: function(item) {
					return '<div>' + item.mark.toUpperCase() + (item.isFlash ? '<span class="label label-info">flash</span>' : '') + '</div>';
				}
			},
			load: null
		},
		options: null
	};
	
	selectizeSubject = {
		config: {
			valueField  : 'subject',
			labelField  : 'subject',
			searchField : 'subject'
		},
		options: []
	};
	
	selectizeTemplate = {
		config: {
			valueField  : 'template',
			labelField  : 'template',
			searchField : 'template'
		},
		options: []
	};
	
	
	selectizeWidget = {
		config: {
			maxItems    : 4,
			valueField  : 'name',
			labelField  : 'caption',
			searchField : 'caption'
		},
		options: []
	};

	selectizeBadges = {
		config: {
			maxItems    : 4,
			valueField  : 'name',
			labelField  : 'caption',
			searchField : 'caption'
		},
		options: []
	};
	
	
	paidStatusSelectize = {
		config: {
			maxItems    : 4,
			valueField  : 'name',
			labelField  : 'caption',
			searchField : 'caption'
		},
		options: []
	};

	refGroups = [];
	
	refGroupList = [];
	
	refSourceList = [];
	
	// Настройки выпадающих списков фильтров по странам и городам
	public selectizeLocation = {
		config: {
			valueField  : 'ccode',
			labelField  : 'caption',
			searchField : 'caption',
			maxItems    : 4,
			closeAfterSelect: true
		},
		options: []
	};
	
	public selectizeCity = {
		config: {
			valueField  : 'name',
			labelField  : 'caption',
			searchField : 'caption',
			maxItems    : 4,
			
			closeAfterSelect: true
		},
		options: []
	};
	
	
	public expandGroup = [
		'filter',
		'date',
		'user-type',
		'source',
		'processor-type',
		'siteFilter',
		'sites',
		'settings',
		'geo',
		'experiment'
	];
	
	public refererTypes = ['first', 'created', 'last', 'paid'];
	
	public refExtendedFilterOperators = [
		'equal', 'contains', 'starts', 'ends',
		'regexp', 'empty', 'not equal', 'not contains', 'not start',
		'not end', 'not regexp', 'not empty'
	];

	expandIds = [];

	baseUrl: string = this.router.url.split('?')[0];
	
	
	userPaidStatusList = [
		'inPaidMode', 'isOrWasPaidMode', 'isPaid', 'isNotPaid', 'isFree', 'isPaidExpired', 'uncompBacket',
		'isDidNotPaid'
	];
	
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		public filter: FilterFormService,
		private _translate: TranslateService,
		private accessorService: AccessorService,
		public helper: HelperService,
		public groupRef: GroupRefService,
		private modalService: ModalService
		
	) {
		const me = this;
		
		me.dictionary = dictionary;
		
		me.selectize.config.load = limiter(function(value, cb) {
			me.filter.getPromocodeList({ promocodeMark: value }).subscribe(({ stats }) => cb(stats));
		});
		
		me.filter.getPromocodeList({}).subscribe(({ stats }) => {
			me.selectize.options = stats;
		});
		
		me.subjectList.forEach(function(subject, i) {
			me.selectizeSubject.options.push({_id: i, subject: subject});
		});
		
		me.templateList.forEach(function(template, i) {
			me.selectizeTemplate.options.push({_id: i, template: template});
		});
		
		me.selectizeLocation.options = [...me.locations];
		
		me.selectizeCity.config['load'] = me.helper.delimit(function(query, cb) {
			me.filter
				.getCityList(me.filter.filterParams.countries[0], query)
					.subscribe(cb);
		});
		
		me.selectizeWidget.options = [...dictionary.widgetList].map(w => ({
			caption : me._translate.__(`widgets.${w}.name`),
			name    : w
		}));
		
		me.selectizeBadges.options = [...dictionary.badgeList].map(b => ({
			caption : me._translate.__(`bages.${b}.name`),
			name    : b
		}));
		
		
		me.paidStatusSelectize.options = ['trial', 'trialExpired', 'paid', 'paidExpired'].map(value => {
			return {
				caption: me._translate.__('adminstat.filterForm.paidStatusList.' + value),
				name   : value
			};
		});
	}
	
	
	get locations() { return this.dictionary.locations }
	get socialFilter() { return this.dictionary.socialFilter }
	get serverAliasList() { return this.dictionary.serverAliasList }
	get serverZoneList() { return this.dictionary.serverZoneList }
	get subjectList() { return this.dictionary.subjectList }
	get templateList() { return this.dictionary.templateList }
	get processorList() { return this.dictionary.processorList }
	get currencyList() { return this.dictionary.currencyList }
	get tariffVariantList() { return this.dictionary.tariffVariantList }
	get tariffIdList() { return this.dictionary.tariffIdList }
	get siteCategories() { return Object.keys(this.dictionary.siteCategories) }
	
	getSubjectsByCategory(category: string) {
		return category && this.dictionary.siteCategories[category] ? Object.keys(this.dictionary.siteCategories[category]) : [];
	}
	
	get emailList() { return Object.keys(this.dictionary.emailList) }
	
	getEmailListWithGroups() {
		return [
			'',
			...Object.keys(this.dictionary.emailList),
			'other',
		];
	}
	
	get localesMap() {
		var me = this;
		return Object.keys(this.dictionary.localesMap).reduce(function(obj, key) {
			obj[key] = me.dictionary.localesMap[key];
			return obj;
		}, {
			'all'    : this._translate.instant('adminstat.common.any'),
			'not_ru' : 'not_ru'
		});
	}

	get createdDevices() {
		return {
			'all': this._translate.instant('adminstat.common.any'),
			'mobile': 'Mobile',
			'tablet': 'Tablet',
			'desktop': 'Desktop',
		};
	}

	async ngOnInit() {
		const me = this;

		me.refGroups = await me.filter.groupRef.getGroups().toPromise();
		
		me.refGroupList = await me.filter.getRefGroupFilterList();
		
		const refGroup = me.filter.filterParams.refGroup;
		if (refGroup && refGroup !== 'all' && refGroup !== 'Direct') {
			const group = me.refGroups.find(g => g.name === refGroup);
			
			const refSourceList = await me.groupRef.getSources(group.id).toPromise();
			me.refSourceList = refSourceList.map(s => s.name);
		}
		
		this.filter.addFilterParams = this.addFilterParams;
		
		let expandMap = this.expandGroup.reduce(function(expandGroup, key) {
			expandGroup[key] = getCookie(key);
			return expandGroup;
		}, {});
		
		me.expandIds = [];
		Object.keys(expandMap).forEach(function(group) {
			if (expandMap[group] == 'true') {
				me.expandIds.push(group);
			}
		});
	}
	
	
	// Применить фильтры
	async applyFilters() {
		const me = this;
		
		me.filter.filterParams.page = 1;
		
		if (me.filter.filterParams.experimentName !== '') {
			me.filter.filterParams[me.filter.filterParams.experimentName] = me.filter.filterParams.experimentValue;
		}
		
		const params = me.filter.getApplyFilters(me.filter.filterParams), 
			url    = me.router.url.split('?')[0];
		
		me.filter.renderFilterTags(params);
		
		const paramsAsStr = qs.stringify(params, { encode: false });
		
		me.filter.setReportGUID();
		
		// Если это режим фильтров для Панели асессоров, то сохранить конфиг в mysql.
		// В противном случае сделать обычную url навигацию
		if (me.isAccessorFilters) {
			await me.accessorService.saveConfig(params).toPromise();
			
			return ;
		}
		
		
		me.router.navigateByUrl(`${url}?${paramsAsStr}`, { relativeTo: me.route });
	}
	
	
	// Сбросить фильтры
	async resetFilters() {
		this.filter.filterParams = new FilterParams();
		this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params: FilterParams = merge({}, this.filter.getDiffParams(this.filter.filterParams)),
			url = this.router.url.split('?')[0];

		delete params.dateFilters;
		delete params.isRegDay;
		delete params.isBilling;
		delete params.isDomainBilling;
		delete params.isExpiredDomains;
		delete params.isNotice;
		delete params.dateFilterParams;
		delete params.userType;
		delete params.dateType;

		if (this.isAccessorFilters) {
			// Если это режим фильтров для Панели асессоров, то не нужно никаких тегов при нажатии на кнопку "Сбросить фильтры"
			this.filter.renderFilterTags({});

			// Если это режим фильтров для Панели асессоров, то сохранить конфиг в mysql
			this.filter.filterParams = new FilterParams();
			this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

			await this.accessorService.saveConfig(qs.stringify(params, {encode: false})).toPromise();
		} else {
			this.filter.renderFilterTags(this.filter.addFilterParams);

			this.router.navigate([url], {relativeTo: this.route, queryParams: params});
		}
	}
	
	
	// Смена типа фильтра по реферерам (Простой, Расширенный)
	changeRefererType(type: string) {
		if (type == this.filter.filterParams.refererFilterType) return true;
		
		this.filter.filterParams.refererFilterType = type;
		
		if (type == 'extended') {
			this.filter.filterParams.refGroup  = 'all';
			this.filter.filterParams.refSource = 'all';
			
			this.filter.filterParams.refExtendedFilters.push(<RefExtendedParams>{
				refererType: this.filter.filterParams.refererType || 'first',
				searchByMarkUtm: 'utm_source',
				searchByMarkRule: 'equal',
				refererSearchValue: ''
			});
		} else if (type == 'simple') {
			this.filter.filterParams.refExtendedFilters = [];
		}
	}
	
	
	// Расширенный фильтр по реферерам - Удалить правило
	refMinus() {
		if (this.filter.filterParams.refExtendedFilters.length <= 1) {
			return true;
		}
		
		this.filter.filterParams.refExtendedFilters.splice(this.filter.filterParams.refExtendedFilters.length - 2, 2);
	}
	
	
	// Расширенный фильтр по реферерам - Добавить правило
	refPlus(cond: string) {
		this.filter.filterParams.refExtendedFilters.push(<RefExtendedParams>{
			condition: cond
		});
		
		this.filter.filterParams.refExtendedFilters.push(<RefExtendedParams>{
			refererType: 'first',
			searchByMarkUtm: 'utm_source',
			searchByMarkRule: 'equal',
			refererSearchValue: ''
		});
	}
	
	
	onAccordionClick($event: NgbPanelChangeEvent) {
		setCookie($event.panelId, $event.nextState);
	}
	
	
	onUserPaidTypeChange(userPaidType) {
		const me = this;
		
		if (userPaidType === 'uncompBacket') {
			if ( ! me.filter.filterParams.dateFilterParams['uncompBacketTime']) {
				me.prevDateType = me.filter.filterParams.dateType;
				me.filter.filterParams.dateType = 'uncompBacketTime';
				me.filter.filterParams.dateFilterParams['uncompBacketTime'] = new DateParams();
				me.filter.filterParams.dateFilterParams['uncompBacketTime'].type = 'other';
			}
		} else if (me.filter.filterParams.dateFilterParams['uncompBacketTime']) {
			me.filter.filterParams.dateType = me.prevDateType;
			delete me.filter.filterParams.dateFilterParams['uncompBacketTime'];
		}
	}
	
	
	async onRefGroupSelect(refGroup: string) {
		this.refSourceList = await this.filter.getRefSourceFilterList(refGroup);
	}
	
	
	onPaidStatusChange() {
		const me           = this,
			{ paidStatus } = me.filter.filterParams;
		
		if (paidStatus !== 'trial') {
			delete me.filter.filterParams.trialStart;
			delete me.filter.filterParams.trialEnd;
		}
	}
	
	async showReporQueries() {
		const modal = this.modalService.openEmpty(ReporQueriesModalComponent, {size: '1000px'});
		const { queries } = await this.filter.getReportQueries().toPromise();
		
		this.modalService.fillData(modal, {title: 'SQL запросы', queries}).result.then(() => {});
	}
}
